
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetonashikcab() {



    const cardData =
    {
        keyword: 'Pune to Nashik Cab',
        heading: 'Meghana Cab : Pune to Nashik Cab',
        headingDescription: 'Meghana Cab offers Pune to Nashik Cab services, delivering a comfortable, safe, and efficient journey between two of Maharashtra’s prominent cities. Whether you are traveling for vineyard tours, religious visits, business, or a relaxing weekend getaway, our clean and well-maintained cabs with experienced drivers ensure a smooth ride. Enjoy transparent pricing, multiple vehicle options to suit your group size and budget, on-time pickups, and 24/7 customer support. Book your Pune to Nashik Cab with Meghana Cab and travel conveniently, reliably, and with complete peace of mind.',


        top: 'Top Places to Visit in Nashik with Meghana Cab',

"topPlaces": [
  {
    "title": "Trimbakeshwar Temple",
    "description": "One of the twelve Jyotirlingas in India, Trimbakeshwar Temple is located at the source of the Godavari River, about 30 km from Nashik city. The temple is architecturally significant with black stone construction and houses three lingas representing Brahma, Vishnu, and Shiva. It is a major spiritual destination and hosts several important religious rituals and Kumbh Mela events."
  },
  {
    "title": "Sula Vineyards",
    "description": "India’s leading wine producer, Sula Vineyards offers a beautiful vineyard experience with wine tasting, winery tours, and panoramic views of lush grape plantations. Visitors can explore the process of wine-making and enjoy dining at the in-house restaurant. It’s a popular spot for couples and tourists looking to experience the modern wine culture in Nashik."
  },
  {
    "title": "Panchavati",
    "description": "This sacred area of Nashik is closely associated with the Ramayana. It is believed that Lord Rama, Sita, and Lakshman spent part of their exile here. Panchavati is home to important temples and landmarks such as Kalaram Temple, Sita Gufa, and Kapaleshwar Mandir. The area attracts devotees and pilgrims year-round due to its mythological and spiritual significance."
  },
  {
    "title": "Pandav Leni Caves",
    "description": "Dating back to the 1st century BCE, the Pandav Leni Caves are a group of ancient rock-cut Buddhist caves situated on a hill near Nashik. The site features beautifully carved prayer halls, viharas, inscriptions, and sculptures. A stairway leads visitors to the caves, which offer a mix of history, religion, and scenic views of the surrounding city."
  },
  {
    "title": "Kalaram Temple",
    "description": "A significant Hindu temple in Panchavati, the Kalaram Temple is known for its black stone idol of Lord Rama. Built in the 18th century by Sardar Rangarao Odhekar, the temple has an architectural resemblance to northern Indian temples and holds great religious importance. It also played a notable role in Dr. B. R. Ambedkar’s temple entry movement."
  },
  {
    "title": "Saptashrungi Devi Temple",
    "description": "Situated about 60 km from Nashik, this temple is dedicated to Goddess Saptashrungi, an incarnation of Durga. It is perched on a cliff with over 500 steps leading up to the shrine, offering a breathtaking view of the mountains. The temple is considered highly sacred and is often visited by pilgrims from across Maharashtra."
  },
  {
    "title": "Anjneri Hills",
    "description": "Believed to be the birthplace of Lord Hanuman, Anjneri Hills is a trekking destination located near Trimbakeshwar. The hills are dotted with ancient caves, temples, and offer panoramic views. The moderate trek and religious significance make it popular among both nature lovers and pilgrims."
  },
  {
    "title": "Someshwar Waterfall",
    "description": "Located near the Gangapur Dam, this scenic waterfall is a favorite picnic spot among locals. Best visited during the monsoon season, the area around Someshwar is lush and ideal for short hikes, nature walks, and peaceful outings away from city noise."
  },
  {
    "title": "Gangapur Dam",
    "description": "A tranquil location near Nashik, the Gangapur Dam on the Godavari River is perfect for watching sunsets and relaxing by the water. It also supplies drinking water to the city. Bird watchers and photography enthusiasts often visit for the serene environment and natural charm."
  },
  {
    "title": "Muktidham Temple",
    "description": "Located in the city, Muktidham is a unique marble temple complex that replicates the 12 Jyotirlingas and other Hindu pilgrimage sites. Built in white Makrana marble, it is known for its clean design and spiritual ambiance. Pilgrims often visit it as a symbolic representation of the real pilgrimage circuits."
  }
],

"services": [
    {
        "name": "Pune to Nashik Cab Booking",
        "description": "Book your Pune to Nashik cab with Meghana Cab for a smooth, reliable, and comfortable travel experience. Whether it’s for business, leisure, or a family trip, we offer multiple cab options including hatchbacks, sedans, and SUVs with professional drivers ensuring a hassle-free journey."
    },
    {
        "name": "One Way Cab Pune to Nashik",
        "description": "Meghana Cab offers convenient one-way cab services from Pune to Nashik at affordable rates. Ideal for solo travelers or those planning a one-time visit, our one-way taxis are available 24/7 with clean vehicles and courteous drivers ensuring a seamless ride."
    },
    {
        "name": "Round Trip Taxi Pune to Nashik",
        "description": "Planning a return journey? Choose Meghana Cab’s round trip taxi service from Pune to Nashik for greater flexibility and better value. Enjoy same-day returns or extended stays with reliable pickups and well-maintained cabs for your comfort and convenience."
    },
    {
        "name": "AC Taxi Pune to Nashik",
        "description": "Beat the heat on your trip to Nashik with our air-conditioned taxi services. Meghana Cab provides cool, clean, and well-equipped AC cars for a relaxed highway ride between Pune and Nashik, perfect for all types of travelers."
    },
    {
        "name": "Affordable Cab Hire Pune to Nashik",
        "description": "Looking for a cost-effective cab to Nashik from Pune? Meghana Cab offers budget-friendly cab rentals with transparent fares and no hidden charges. Choose from a variety of vehicles to fit your needs without breaking the bank."
    },
    {
        "name": "SUV Rental Pune to Nashik",
        "description": "Traveling in a group or need extra space? Book an SUV cab from Pune to Nashik with Meghana Cab. Our spacious and comfortable SUVs are ideal for family trips, group travel, and long-distance comfort with luggage."
    },
    {
        "name": "Book Sedan Pune to Nashik Trip",
        "description": "For a premium yet affordable experience, hire a sedan for your Pune to Nashik journey. Meghana Cab’s sedans are perfect for business travel, couples, or small families looking for a smooth and quiet ride."
    },
    {
        "name": "Pune to Nashik Distance by Cab",
        "description": "The distance from Pune to Nashik by cab is approximately 210 km, taking about 4.5 to 5 hours depending on traffic and route. Meghana Cab ensures a smooth and timely ride with comfortable vehicles and knowledgeable drivers."
    },
    {
        "name": "Nashik Wine Tour Cab Pune",
        "description": "Planning a wine tour to Nashik? Meghana Cab offers specialized cab services for Nashik vineyard visits and wine tasting tours from Pune. Enjoy the scenic countryside and top wineries like Sula with our chauffeur-driven comfortable vehicles."
    },
    {
        "name": "24/7 Pune to Nashik Cabs",
        "description": "Need a cab anytime of day or night? Meghana Cab offers 24/7 taxi services from Pune to Nashik with instant booking, safe drivers, and on-time service to meet your travel needs round the clock."
    },
    {
        "name": "Pune to Nashik Business Travel Taxi",
        "description": "For corporate clients and professionals, Meghana Cab provides business-class travel from Pune to Nashik. Our clean, punctual, and executive taxis ensure a professional travel experience tailored for meetings and business travel needs."
    },
    {
        "name": "Online Cab Pune to Nashik",
        "description": "Book your Pune to Nashik cab online easily with Meghana Cab. Choose your preferred vehicle, view fares instantly, and confirm your trip with just a few clicks. Our platform ensures easy access to quality travel services."
    },
    {
        "name": "Pune to Nashik Cab Fare Estimate",
        "description": "Get a quick fare estimate for your Pune to Nashik cab before booking. Meghana Cab provides transparent pricing with detailed breakup including tolls and taxes so you can plan your budget effectively."
    },
    {
        "name": "Fast Cab Hire Pune to Nashik",
        "description": "Need a quick cab to Nashik from Pune? Meghana Cab offers fast booking options and rapid dispatch so you don’t waste time. Perfect for last-minute travel plans or emergencies."
    },
    {
        "name": "Family Trip Cab Pune to Nashik",
        "description": "Make your family road trip to Nashik enjoyable and safe with Meghana Cab’s spacious and family-friendly taxi services. Our vehicles come with ample legroom, clean interiors, and experienced drivers who prioritize your comfort."
    }
],

"tableData": [
    ["Pune to Nashik Cab Booking", "One Way Cab Pune to Nashik"],
    ["Round Trip Taxi Pune to Nashik", "AC Taxi Pune to Nashik"],
    ["Affordable Cab Hire Pune to Nashik", "SUV Rental Pune to Nashik"],
    ["Book Sedan Pune to Nashik Trip", "Pune to Nashik Distance by Cab"],
    ["Nashik Wine Tour Cab Pune", "24/7 Pune to Nashik Cabs"],
    ["Pune to Nashik Business Travel Taxi", "Online Cab Pune to Nashik"],
    ["Pune to Nashik Cab Fare Estimate", "Fast Cab Hire Pune to Nashik"],
    ["Family Trip Cab Pune to Nashik", ""]
],










"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Nashik Cab Service",
        "WhyChoosedescription": "Meghana Cab offers a dependable and comfortable Pune to Nashik cab service for leisure trips, business travel, and family visits. Our focus is on providing a smooth, hassle-free ride across this scenic intercity route."
    },
    {
        "WhyChooseheading": "Comfortable and Clean Vehicles for Long-Distance Travel",
        "WhyChoosedescription": "All our cabs—sedans, SUVs, and tempo travellers—are air-conditioned, spacious, and regularly sanitized to ensure a relaxing and hygienic journey from Pune to Nashik, especially for trips lasting 5–6 hours."
    },
    {
        "WhyChooseheading": "Professional Drivers with Route Expertise",
        "WhyChoosedescription": "Our drivers are courteous, licensed, and experienced in intercity travel. They know the best routes via NH60 and avoid traffic-prone areas to ensure a safe and timely arrival in Nashik."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "With Meghana Cab, you get fixed, all-inclusive fares for your Pune to Nashik cab—no hidden charges, surge pricing, or surprise toll costs. We believe in offering honest pricing that fits your budget."
    },
    {
        "WhyChooseheading": "Flexible Options: One-Way, Round Trip & Same-Day Return",
        "WhyChoosedescription": "Choose from multiple booking options including one-way drops, round trips, or even same-day return cabs to Nashik, depending on your schedule and travel purpose."
    },
    {
        "WhyChooseheading": "24/7 Availability for Any Travel Plan",
        "WhyChoosedescription": "Planning an early morning vineyard tour or a late-night return from a temple visit? Meghana Cab operates round-the-clock, so your Pune to Nashik trip can start or end anytime you need."
    },
    {
        "WhyChooseheading": "Instant Booking with Easy Modifications",
        "WhyChoosedescription": "Book your cab in under a minute through our website, app, or phone call. Modify travel time, add a stop, or extend your journey with ease thanks to our flexible booking policies and support team."
    },
    {
        "WhyChooseheading": "Safe Travel with Real-Time Tracking and Support",
        "WhyChoosedescription": "Every cab is GPS-enabled and monitored for safety. You’ll receive live tracking and driver information, with our 24/7 support team ready to assist you throughout your journey."
    }
]









































    }

const faqData = [
    {
        question: "How can I book a cab from Pune to Nashik with Meghana Cab?",
        answer: "You can easily book a Pune to Nashik cab by calling Meghana Cab at +91 9075462128 or via our website."
    },
    {
        question: "What types of vehicles are available for Pune to Nashik trips?",
        answer: "We offer sedans, SUVs, and tempo travellers to accommodate your group size and comfort."
    },
    {
        question: "Are Meghana Cab drivers experienced with Pune to Nashik routes?",
        answer: "Yes, our drivers know the best routes to ensure a safe and timely journey from Pune to Nashik."
    },
    {
        question: "Can I book a one-way or round-trip cab from Pune to Nashik?",
        answer: "Yes, both one-way and round-trip cab services are available."
    },
    {
        question: "What is included in the Pune to Nashik cab fare?",
        answer: "The fare covers driver charges, fuel, tolls, and vehicle maintenance. Additional charges may apply based on your trip."
    },
    {
        question: "Are Meghana Cab vehicles sanitized for safety?",
        answer: "Yes, all vehicles are regularly cleaned and sanitized to ensure your safety and comfort."
    },
    {
        question: "Is Meghana Cab available 24/7 for Pune to Nashik bookings?",
        answer: "Yes, our services operate round-the-clock to fit your schedule."
    },
    {
        question: "Can I request special requirements like child seats for Pune to Nashik trips?",
        answer: "Yes, special requests can be arranged at the time of booking."
    },
    {
        question: "What payment methods are accepted for Pune to Nashik cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "How can I contact Meghana Cab for Pune to Nashik cab services?",
        answer: "Call Meghana Cab at +91 9075462128 to book or inquire about Pune to Nashik cab services."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Vijay Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Pune to Nashik cab service by Meghana Cab was smooth and comfortable. Highly recommended!”',
    },
    {
        name: 'Ms. Sneha Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Professional driver and clean vehicle made our Pune to Nashik trip pleasant with Meghana Cab.”',
    },
];





































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Nashik Cab",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-nashik-cab.jpg",
  "description": "Book Pune to Nashik cab with Meghana Cabs for reliable one way or round trip travel. Choose from AC sedans, SUVs, and budget options with professional drivers and timely service.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "5890"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-nashik-cab"
  }
};





    return (
        <div>
<Helmet>
  <title>Pune to Nashik Cab | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Nashik cab with Meghana Cabs for reliable one way or round trip travel. Choose from AC sedans, SUVs, and budget options with professional drivers and timely service." 
  />
  <meta 
    name="keywords" 
    content="Pune to Nashik Cab Booking, One Way Cab Pune to Nashik, Round Trip Taxi Pune to Nashik, AC Taxi Pune to Nashik, Affordable Cab Hire Pune to Nashik, SUV Rental Pune to Nashik, Book Sedan Pune to Nashik Trip, Pune to Nashik Distance by Cab, Nashik Wine Tour Cab Pune, 24/7 Pune to Nashik Cabs, Pune to Nashik Business Travel Taxi, Online Cab Pune to Nashik, Pune to Nashik Cab Fare Estimate, Fast Cab Hire Pune to Nashik, Family Trip Cab Pune to Nashik" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/35.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetonashikcab;